


window.addEventListener("DOMContentLoaded", () => {
  const vatToggleSwitch = document.querySelector('.toggle-vat-switch input');

  booleanValue = false;
  if(sessionStorage.getItem("prices-with-vat") !== null){
    const storedVatPreference = sessionStorage.getItem("prices-with-vat");
    booleanValue = JSON.parse(storedVatPreference.toLowerCase());
    vatToggleSwitch.checked = booleanValue;
  } else {
    const isChecked = vatToggleSwitch.checked;
    booleanValue = isChecked ? true : false;
    sessionStorage.setItem("prices-with-vat", booleanValue)
  }
  
  updateVatProductPrice('[data-price-with-vat]', booleanValue);
  updateVatProductPrice('[data-price-with-vat-mini]', booleanValue);
  updateVatProductPrice('[data-cart-price-with-vat]', booleanValue);



  vatToggleSwitch.addEventListener('change', function () {
    const isChecked = this.checked; 
  
    const value = isChecked ? true : false;
    sessionStorage.setItem("prices-with-vat", value);
    updateVatProductPrice('[data-price-with-vat]', value);
    updateVatProductPrice('[data-price-with-vat-mini]', value);
    updateVatProductPrice('[data-cart-price-with-vat]', value);
    //updateVatPricePDP(value);
  });


});
function updateVatPricePDP(price){
 
  const vat_percentage = parseFloat(document.body.getAttribute('data-vat-percentage')) || 0;

  let updatedPrice = "";

  if(!booleanValue){
    const storedVatPreference = sessionStorage.getItem("prices-with-vat");
    booleanValue = JSON.parse(storedVatPreference.toLowerCase());
  }
  if(booleanValue){
    price = price/100;
    let divisor = 100 + vat_percentage;
    updatedPrice = (price / divisor) * 100;

    updatedPrice = updatedPrice.toFixed(2);
    updatedPrice = updatedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  } else{
    updatedPrice = price;
  }

  return updatedPrice;
}

function updateVatProductPrice(selector, booleanValue = ""){
  
  if(!booleanValue){
    const storedVatPreference = sessionStorage.getItem("prices-with-vat");
    booleanValue = JSON.parse(storedVatPreference?.toLowerCase());
  }
  const vat_percentage = parseFloat(document.body.getAttribute('data-vat-percentage')) || 0;
  const currency_symbol = document.body.getAttribute('data-currency-symbol') || '';

  const elements = document.querySelectorAll(selector);
  
  elements.forEach((element) => {
    const attributeName = selector.replace(/[\[\]]/g, '');
    let priceVatAttr = element.getAttribute(attributeName);
    let price = ""
    if(Shopify.currency.active === "PLN" ){
      let amount = priceVatAttr.replace(",", ".");
      let parts = amount.split(".");
      let lastPart = parts.pop();
      let integerPart = parts.join("");
      let normalizedAmount = integerPart + "." + lastPart;
      price = parseFloat(normalizedAmount);
    } else {
      priceVatAttr = priceVatAttr.replace(",", "")
      price = parseFloat(priceVatAttr) || 0;
    }
    if (!price) return;

    let divisor = 100 + vat_percentage;
    let updatedPrice = booleanValue
        ? (price / divisor) * 100
        : price;

    updatedPrice = parseFloat(updatedPrice.toFixed(2));
    let formattedPrice = ""

    if(Shopify.currency.active === "PLN"){
      let num = updatedPrice.toFixed(2).replace(".", ",")
      let [integerPart, decimalPart] = num.toString().split(",");
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");  
      formattedPrice = integerPart + "," + decimalPart;
    } else {
      formattedPrice = updatedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    element.textContent = Shopify.currency.active === "PLN"
        ? `${formattedPrice} ${currency_symbol}`
        : `${formattedPrice} ${currency_symbol}`;
  });
}